export const getImage = (state) => state.imageToText.image;
export const getResult = (state) => state.imageToText.result;